import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  fullWidth: {
    width: "100%",
  },
}));
